(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-logos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLogoRow(section) {
    const wrapper = section.querySelector(".sb-featured-logo-v2");
    if (!wrapper) return;

    if (!wrapper.dataset.originalHtml) {
      wrapper.dataset.originalHtml = wrapper.innerHTML;
    }

    const speed = parseInt(wrapper.dataset.marqueeSpeed || "18", 10);
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    wrapper.classList.remove("is-marquee", "is-scroll");
    wrapper.innerHTML = wrapper.dataset.originalHtml;
    wrapper.style.removeProperty("--sb-marquee-distance");
    wrapper.style.removeProperty("--sb-marquee-duration");

    if (!isMobile) return;

    const items = Array.from(wrapper.querySelectorAll(".sb-featured-logo-item"));

    if (items.length >= 3) {
      wrapper.classList.add("is-marquee");
      wrapper.style.setProperty("--sb-marquee-duration", speed + "s");

      const track = document.createElement("div");
      track.className = "sb-marquee-track";

      items.forEach(i => track.appendChild(i));
      items.forEach(i => track.appendChild(i.cloneNode(true)));

      wrapper.innerHTML = "";
      wrapper.appendChild(track);

      requestAnimationFrame(() => {
        let width = 0;
        const half = Math.floor(track.children.length / 2);
        for (let i = 0; i < half; i++) {
          width += track.children[i].getBoundingClientRect().width;
        }
        const gap = parseFloat(getComputedStyle(track).gap || 0);
        width += gap * Math.max(0, half - 1);
        wrapper.style.setProperty("--sb-marquee-distance", width + "px");
      });
    } else {
      wrapper.classList.add("is-scroll");
    }
  }

  function initAll() {
    document.querySelectorAll(".sb-featured-section").forEach(initLogoRow);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
